
(function () {
    'use strict';

    angular.module('NewsCategoryModule', [])
           .controller('NewsCategoryController', NewsCategoryController);

    NewsCategoryController.$inject = ['$state', '$scope','newsService'];

    function NewsCategoryController($state, $scope, newsService) {
        var vm = this;
        vm.loadNews = loadNews;
        vm.toggleLoadAllNews = false;
        vm.news = [];
        vm.currentPage = -1;
        vm.startPage = -1;
        vm.totalResults = 0;
        vm.maxDisplayPage = NewsGridConfig.maxDisplayPage;
        vm.itemPerPage = HandbookConfiguration.NewsPageSize;
        vm.pageSize = HandbookConfiguration.NewsPageSize;
        vm.translation = {
            title: globalResources.CommonGridColumns.Title,
            createdDate: globalResources.CreatedDate,
            first: globalResources.First,
            last: globalResources.Last,
            description: globalResources.Description,
            publishedDate: globalResources.Published
        };

        vm.newsSetting = [];
        function newsSetting() {
            vm.newsSetting.push({ id: 'title', name: vm.translation.title, width: 30, coldefault: true });
            vm.newsSetting.push({ id: 'dtmPublish', name: vm.translation.publishedDate, width: 20, coldefault: true });
            vm.newsSetting.push({ id: 'ingress', name: vm.translation.description, width: 50, coldefault: true });
        };

        initialize();
        function initialize() {
            newsSetting();
            loadAllNews($state.params.pageIndex);
        };
        function loadNews(id) {
            newsService
                .updateNewsReadCount(id)
                .then(function (result) {
                    $state.go(handbookActions.StartpageNews, { newsId: id, isPreview: false });
                });
        };

        function loadAllNews(pageIndex, pageSize) {
            if (!pageIndex || pageIndex == -1) {
                pageIndex = 1;
            }
            if (pageIndex != vm.startPage) {
                user.currentNewsPage = pageIndex;
                newsService
                    .getNewsByCategoryId($state.params.categoryId, E.NewsCategoryShownIn.shownInHandbookFrontend, pageIndex - 1, pageSize || vm.pageSize)
                    .then(function (result) {
                        vm.news = result.data.news;
                        vm.totalResults = result.data.totalResults;
                        vm.currentPage = pageIndex;
                        vm.startPage = pageIndex;
                    });
            }
        };

        $scope.$watch('vm.currentPage', function (newPage) {
            if (vm.currentPage != -1) {
                loadAllNews(newPage);
            }
        });

    };
})();

